import React, { useEffect, useState } from 'react';
import { ProviderRoles } from '@/common/const';
import { useExerUser } from '@/common/hooks/ExerUser';
import { useHttpContext } from '@/common/hooks/HttpContext';
import { toasts } from '@/common/toasts';
import { Location, PaginationMeta, PaginationOrder } from '@/common/types';
import { resultIsError } from '@/services/HttpService';
import { LocationsList } from './LocationsList';

const PAGE_SIZE = 20;

export const LocationsListContainer = () => {
    const { httpService } = useHttpContext();
    const { getRole, user } = useExerUser();
    const { errorToast } = toasts;

    const [allLocations, setAllLocations] = useState<Location[]>();
    const [allMetadata, setAllMetadata] = useState<PaginationMeta>();
    const [allPage, setAllPage] = useState(1);
    const [allOrder, setAllOrder] = useState<PaginationOrder>('ASC');

    const [userLocations, setUserLocations] = useState<Location[]>();
    const [userMetadata, setUserMetadata] = useState<PaginationMeta>();
    const [userPage, setUserPage] = useState(1);
    const [userOrder, setUserOrder] = useState<PaginationOrder>('ASC');

    useEffect(() => {
        (async () => {
            const res = await httpService.getLocationPages({ page: allPage, limit: PAGE_SIZE, order: allOrder });
            if (resultIsError(res)) {
                errorToast('Unable to get locations');
                return;
            }
            setAllLocations(res.items);
            setAllMetadata(res.metadata);
        })();
    }, [allPage, allOrder]);

    const showTabs = getRole() === ProviderRoles.PORTAL_PRACTITIONER;

    useEffect(() => {
        (async () => {
            if (showTabs) {
                const res = await httpService.getLocationPages({
                    page: userPage,
                    limit: PAGE_SIZE,
                    order: userOrder,
                    onlyMine: true,
                });
                if (resultIsError(res)) {
                    errorToast('Unable to get your locations');
                    return;
                }
                setUserLocations(res.items);
                setUserMetadata(res.metadata);
            }
        })();
    }, [userPage, userOrder]);

    const handleToggleAllOrder = () => {
        setAllPage(1);
        setAllOrder((prev) => (prev === 'ASC' ? 'DESC' : 'ASC'));
    };

    const handleToggleUserOrder = () => {
        setUserPage(1);
        setUserOrder((prev) => (prev === 'ASC' ? 'DESC' : 'ASC'));
    };

    return (
        <LocationsList
            locations={allLocations}
            userLocations={userLocations}
            showTabs={showTabs}
            allPage={allPage}
            allOrder={allOrder}
            allMetadata={allMetadata}
            onAllPageChange={setAllPage}
            onToggleAllOrder={handleToggleAllOrder}
            userPage={userPage}
            userOrder={userOrder}
            userMetadata={userMetadata}
            onUserPageChange={setUserPage}
            onToggleUserOrder={handleToggleUserOrder}
        />
    );
};
